import { ColumnDef } from '@benzinga/table';
import { GovernmentMember, GovernmentTrade, Security, SecurityTrader, MemberTrade } from '@benzinga/gov-trades';

export interface TabData {
  columnsDef: ColumnDef<any>[];
  data: GovernmentTrade[] | SecurityTrader[] | Security[] | MemberTrade[];
  description?: string;
  hideColumns?: string[];
  key: string;
  name: string;
  title?: string;
}

export interface GovTradeOptionI {
  key: string;
  members: GovernmentMember[];
  name: string;
  order: string;
}

export const options: GovTradeOptionI[] = [
  {
    key: 'date_of_last_recorded_trade',
    members: [],
    name: 'Last Traded: New to Old',
    order: 'desc',
  },
  {
    key: 'date_of_last_recorded_trade',
    members: [],
    name: 'Last Traded: Old to New',
    order: 'asc',
  },
  {
    key: 'total_volume_of_trades',
    members: [],
    name: 'Volume: High to Low',
    order: 'desc',
  },
  {
    key: 'total_volume_of_trades',
    members: [],
    name: 'Volume: Low to High',
    order: 'asc',
  },
  {
    key: 'number_of_trades',
    members: [],
    name: 'Total Trades: High to Low',
    order: 'desc',
  },
  {
    key: 'number_of_trades',
    members: [],
    name: 'Total Trades: Low to High',
    order: 'asc',
  },
];

export const FAQsDataSet = [
  {
    question: 'Why do lawmakers report stock trades?',
    answer: `
        Lawmakers are required to report stock trades under the STOCK Act (Stop Trading on Congressional Knowledge Act), which was passed in 2012. This law was created to increase transparency, prevent insider trading, and ensure that public officials are held accountable when their financial interests intersect with their public responsibilities. By disclosing trades over $1,000, the public can monitor whether members of Congress are potentially benefiting from non-public information gained through their positions.
      `,
  },
  {
    question: 'How is the trade data collected?',
    answer: `
      Members of Congress and certain federal officials must file what are known as Periodic Transaction Reports (PTRs) within 45 days of making a qualifying transaction. These reports are submitted to the Clerk of the House or the Secretary of the Senate, depending on the lawmaker’s chamber. While the reports are made publicly available, they are typically posted in PDF format and can be difficult to search or analyze. As a result, journalists, watchdog groups, and third-party platforms often collect and process this data to make it more accessible and useful to the public.
      `,
  },
  {
    question: 'What are the implications of new trades?',
    answer: `When lawmakers report new trades, it can raise questions about potential conflicts of interest, especially if the timing of the trade aligns with legislative actions, hearings, or policy decisions that could influence a company’s stock value. These disclosures allow the public to track patterns, assess the industries lawmakers are investing in, and identify any possible use of privileged information. While a trade disclosure does not automatically indicate misconduct, it can trigger public scrutiny, media attention, or even ethics investigations if the circumstances appear questionable. Ultimately, these reports serve as a tool to hold public officials accountable and maintain trust in government institutions.`,
  },
];

export const americanStates = [
  { name: 'Alaska', state: 'AK' },
  { name: 'Alabama', state: 'AL' },
  { name: 'Arkansas', state: 'AR' },
  { name: 'Arizona', state: 'AZ' },
  { name: 'California', state: 'CA' },
  { name: 'Colorado', state: 'CO' },
  { name: 'Connecticut', state: 'CT' },
  { name: 'Delaware', state: 'DE' },
  { name: 'Florida', state: 'FL' },
  { name: 'Georgia', state: 'GA' },
  { name: 'Hawaii', state: 'HI' },
  { name: 'Iowa', state: 'IA' },
  { name: 'Idaho', state: 'ID' },
  { name: 'Illinois', state: 'IL' },
  { name: 'Indiana', state: 'IN' },
  { name: 'Kansas', state: 'KS' },
  { name: 'Kentucky', state: 'KY' },
  { name: 'Louisiana', state: 'LA' },
  { name: 'Massachusetts', state: 'MA' },
  { name: 'Maryland', state: 'MD' },
  { name: 'Maine', state: 'ME' },
  { name: 'Michigan', state: 'MI' },
  { name: 'Minnesota', state: 'MN' },
  { name: 'Missouri', state: 'MO' },
  { name: 'Mississippi', state: 'MS' },
  { name: 'Montana', state: 'MT' },
  { name: 'North Carolina', state: 'NC' },
  { name: 'Nebraska', state: 'NE' },
  { name: 'New Hampshire', state: 'NH' },
  { name: 'New Jersey', state: 'NJ' },
  { name: 'New Mexico', state: 'NM' },
  { name: 'Nevada', state: 'NV' },
  { name: 'New York', state: 'NY' },
  { name: 'Ohio', state: 'OH' },
  { name: 'Oklahoma', state: 'OK' },
  { name: 'Oregon', state: 'OR' },
  { name: 'Pennsylvania', state: 'PA' },
  { name: 'Rhode Island', state: 'RI' },
  { name: 'South Carolina', state: 'SC' },
  { name: 'South Dakota', state: 'SD' },
  { name: 'Tennessee', state: 'TN' },
  { name: 'Texas', state: 'TX' },
  { name: 'Utah', state: 'UT' },
  { name: 'Virginia', state: 'VA' },
  { name: 'Vermont', state: 'VT' },
  { name: 'Washington', state: 'WA' },
  { name: 'Wisconsin', state: 'WI' },
  { name: 'West Virginia', state: 'WV' },
  { name: 'Wyoming', state: 'WY' },
];
